import { render, staticRenderFns } from "./ExampleSpotPage.vue?vue&type=template&id=1c9d3646"
import script from "./ExampleSpotPage.vue?vue&type=script&lang=js"
export * from "./ExampleSpotPage.vue?vue&type=script&lang=js"
import style0 from "./ExampleSpotPage.vue?vue&type=style&index=0&id=1c9d3646&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports